import { render, staticRenderFns } from "./deliveryCrew.vue?vue&type=template&id=229e8c82"
import script from "./deliveryCrew.vue?vue&type=script&lang=js"
export * from "./deliveryCrew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports